// @ts-nocheck
import { Column } from 'react-table'
import { GroupDiscountInfoCell } from './GroupDiscountInfoCell'
import { GroupDiscountActionsCell } from './GroupDiscountActionsCell'
import { GroupDiscountSelectionCell } from './GroupDiscountSelectionCell'
import { GroupDiscountCustomHeader } from './GroupDiscountCustomHeader'
import { GroupDiscountSelectionHeader } from './GroupDiscountSelectionHeader'
import { GroupDiscount } from '../../core/_models'
import { FormattedMessage } from 'react-intl'

const groupdiscountsColumns: ReadonlyArray<Column<GroupDiscount>> = [
  {
    Header: (props) => <GroupDiscountSelectionHeader tableProps={props} />,
    id: 'selection',
    Cell: ({ ...props }) => <GroupDiscountSelectionCell id={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => (
      <GroupDiscountCustomHeader
        tableProps={props}
        title={<FormattedMessage id="GROUPDISCOUNT.TABLE.COLUMN.GROUPNAME" defaultMessage="Group Name" />}
        className="min-w-125px"
      />
    ),
    id: 'reseller_group',
    accessor: 'reseller_group.name',
  },
  {
    Header: (props) => (
      <GroupDiscountCustomHeader
        tableProps={props}
        title={<FormattedMessage id="GROUPDISCOUNT.TABLE.COLUMN.SERVICE" defaultMessage="Service" />}
        className="min-w-200px"
      />
    ),
    id: 'service',
    accessor: (row) => {
      const serviceCategory = row.service?.service_category?.category_name || 'N/A';
      const companyName = row.service?.company?.company_name || 'N/A';
      return `${serviceCategory} - ${companyName}`;
    },
  },
  {
    Header: (props) => (
      <GroupDiscountCustomHeader
        tableProps={props}
        title={<FormattedMessage id="GROUPDISCOUNT.TABLE.COLUMN.BUNDLE" defaultMessage="Bundle" />}
        className="min-w-125px"
      />
    ),
    id: 'bundle',
    accessor: 'bundle.bundle_title',
  },
  {
    Header: (props) => (
      <GroupDiscountCustomHeader
        tableProps={props}
        title={<FormattedMessage id="GROUPDISCOUNT.TABLE.COLUMN.DISCOUNTTYPE" defaultMessage="Discount Type" />}
        className="min-w-125px"
      />
    ),
    id: 'discount_type',
    accessor: 'discount_type',
  },
  {
    Header: (props) => (
      <GroupDiscountCustomHeader
        tableProps={props}
        title={<FormattedMessage id="GROUPDISCOUNT.TABLE.COLUMN.DISCOUNTVALUE" defaultMessage="Discount Value" />}
        className="min-w-100px"
      />
    ),
    id: 'discount_value',
    accessor: 'discount_value',
  },
  {
    Header: (props) => (
      <GroupDiscountCustomHeader
        tableProps={props}
        title={<FormattedMessage id="GROUPDISCOUNT.TABLE.COLUMN.STATUS" defaultMessage="Status" />}
        className="min-w-100px"
      />
    ),
    id: 'status',
    Cell: ({ row }) => (
      <span
        className={`badge ${row.original.status === 'active' ? 'badge-success' : 'badge-danger'}`}
      >
        {row.original.status === 'active' ? 'Active' : 'Inactive'}
      </span>
    ),
  },
  {
    Header: (props) => (
      <GroupDiscountCustomHeader
        tableProps={props}
        title={<FormattedMessage id="GROUPDISCOUNT.TABLE.COLUMN.NOTES" defaultMessage="Notes" />}
        className="min-w-150px"
      />
    ),
    id: 'notes',
    accessor: 'notes',
  },
  {
    Header: (props) => (
      <GroupDiscountCustomHeader
        tableProps={props}
        title={<FormattedMessage id="GROUPDISCOUNT.TABLE.COLUMN.CREATEDAT" defaultMessage="Created At" />}
        className="min-w-150px"
      />
    ),
    id: 'created_at',
    accessor: 'created_at',
  },
  {
    Header: (props) => (
      <GroupDiscountCustomHeader
        tableProps={props}
        title={<FormattedMessage id="TABLE.GENERAL.ACTION" defaultMessage="Action" />}
        className="text-end min-w-100px"
      />
    ),
    id: 'actions',
    Cell: ({ ...props }) => <GroupDiscountActionsCell id={props.data[props.row.index].id} />,
  },
]

export { groupdiscountsColumns }
